import { getUserDetails, setUserDetails } from '../components/utils/functions';
import { AUTHAPI } from './axios';
import { URLS } from './urls';


export const refreshToken = async () => {
    let token = getUserDetails();
    const newToken = await AUTHAPI.post(URLS.AUTHS.REFRESH, {
        refresh: token.refresh_token
    })
        .then((resp) => {
            token.access_token = resp.data?.access;
            setUserDetails(token);
            return resp.data?.access;
        })
        .catch(() => {
            window.localStorage.setItem('redirect', window.location.pathname);
            window.localStorage.removeItem('user-details');
            window.location.pathname = '/login';
        });
    return newToken;
};
